exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kk-avatar-wrap {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  width: 2rem;\n  height: 2rem;\n}\n.kk-avatar-wrap .kk-avatar-box {\n  position: relative;\n}\n.kk-avatar-wrap .kk-avatar-box .ava {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  -webkit-transform: translate(-50%, 0) scale(0.62);\n          transform: translate(-50%, 0) scale(0.62);\n  z-index: 2;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n}\n.kk-avatar-wrap .kk-avatar-box .head-wear {\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  -webkit-transform: translateX(-50%) scale(1);\n          transform: translateX(-50%) scale(1);\n  z-index: 3;\n  width: 2rem;\n  height: 2rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./component/Header/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./component/Header/index.less
// module chunks = 0